import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import user from './modules/user';
import getters from './getters';
import tagsView from './modules/tagsView';
import * as types from './mutation-types';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    user,
    tagsView
  },
  getters,
  actions: {
    // 应用载入
    appLoad({ commit }) {
      // TODO 应用载入时要调用的mutations
      // 载入User信息
      commit(types.LOAD_USER);
    }
  }
});
